import React from "react";

const StatCardsContainer = ({ children }) => {
  return <div className="new_stat_card__container">{children}</div>;
};

export default StatCardsContainer;
